import React from "react";
import MinimalPublicPage from "./MinimalPublicPage";

export default function ReputationPage() {
  return (
    <MinimalPublicPage
      eyebrow="Reputation"
      title="Your match history should mean something."
      description="Ouro reputation rewards reliability, accountability, and useful play over anonymous one-off lobbies."
      points={[
        {
          title: "Reliability counts",
          body: "Showing up, finishing games, and avoiding disruptive behavior all matter.",
        },
        {
          title: "Reports have context",
          body: "Reports are interpreted alongside match data and review signals, not accepted blindly.",
        },
        {
          title: "Better pools over time",
          body: "The platform can shape future matchmaking around trusted players and cleaner games.",
        },
      ]}
      secondaryLabel="Anti-cheat"
      secondaryTo="/anti-cheat"
    />
  );
}
